import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// --- PrimeNG ---
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

// --- Overlay Panel ---
import { FavoritesDialogComponent } from './favorites-dialog.component';
import { ImageDefaultModule } from '@components/image-default/image-default.module';

@NgModule({
	declarations: [FavoritesDialogComponent],
	imports: [
		CommonModule,
		RouterModule,

		// --- PrimeNG ---
		ButtonModule,
		DividerModule,
		SkeletonModule,
		ProgressSpinnerModule,

		// --- Components ---
		ImageDefaultModule,
	],
	exports: [FavoritesDialogComponent],
})
export class FavoritesDialogModule {}
